(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambient-soundscape"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const STORAGE_KEY = 'soundscape_muted';

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.asc-widget').forEach(function (widget) {

        const audio      = widget.querySelector('audio');
        const pill       = widget.querySelector('.asc-pill');
        const tray       = widget.querySelector('.asc-tray');
        const volSlider  = widget.querySelector('.asc-vol-slider');
        const closeBtn   = widget.querySelector('.asc-tray__close');
        const defaultVol = parseFloat(widget.dataset.defaultVolume) || 0.6;

        if (!audio || !pill) return;

        /* ── 1. INITIAL STATE: always paused, never autoplay ── */
        audio.pause();
        audio.currentTime = 0;
        audio.volume = defaultVol;

        /* Restore volume from sessionStorage mute flag */
        const wasMuted = sessionStorage.getItem(STORAGE_KEY) === 'true';
        if (wasMuted) {
          /* Was muted last time – stay paused (do nothing extra) */
        }

        /* ── 2. WEB AUDIO SYNTH FALLBACK ── */
        let audioCtx   = null;
        let synthNodes = null;
        let synthActive = false;

        function startSynth(vol) {
          try {
            var AC = window.AudioContext || window.webkitAudioContext;
            if (!AC) return false;
            if (!audioCtx) audioCtx = new AC();
            if (audioCtx.state === 'suspended') audioCtx.resume();

            var master = audioCtx.createGain();
            master.gain.setValueAtTime(vol * 0.45, audioCtx.currentTime);
            master.connect(audioCtx.destination);

            var freqs = [108, 216, 596, 1166];
            var oscs = freqs.map(function (f, i) {
              var osc = audioCtx.createOscillator();
              var g   = audioCtx.createGain();
              var lfo = audioCtx.createOscillator();
              var lfoG = audioCtx.createGain();
              osc.type = 'sine';
              osc.frequency.setValueAtTime(f, audioCtx.currentTime);
              osc.detune.setValueAtTime((i % 2 === 0 ? 1 : -1) * (i + 1.5), audioCtx.currentTime);
              lfo.frequency.setValueAtTime(0.12 * (i + 1), audioCtx.currentTime);
              lfoG.gain.setValueAtTime(0.25, audioCtx.currentTime);
              lfo.connect(lfoG);
              g.gain.setValueAtTime(0.18 / (i + 1), audioCtx.currentTime);
              lfoG.connect(g.gain);
              osc.connect(g);
              g.connect(master);
              osc.start();
              lfo.start();
              return { osc: osc, lfo: lfo };
            });

            var strikeInterval = setInterval(function () {
              if (!synthActive || !audioCtx) return;
              try {
                var s  = audioCtx.createOscillator();
                var sg = audioCtx.createGain();
                s.type = 'sine';
                s.frequency.setValueAtTime(432, audioCtx.currentTime);
                sg.gain.setValueAtTime(vol * 0.35, audioCtx.currentTime);
                sg.gain.exponentialRampToValueAtTime(0.0001, audioCtx.currentTime + 6);
                s.connect(sg);
                sg.connect(master);
                s.start();
                s.stop(audioCtx.currentTime + 6.1);
              } catch (e) {}
            }, 8000);

            synthNodes = { master: master, oscs: oscs, interval: strikeInterval };
            synthActive = true;
            return true;
          } catch (e) {
            console.warn('[Soundscape] Synth error:', e);
            return false;
          }
        }

        function stopSynth() {
          if (synthNodes) {
            try {
              clearInterval(synthNodes.interval);
              synthNodes.oscs.forEach(function (n) { n.osc.stop(); n.lfo.stop(); });
              if (audioCtx) audioCtx.suspend();
            } catch (e) {}
            synthNodes = null;
          }
          synthActive = false;
        }

        /* ── 3. PLAYING STATE HELPER ── */
        function setPlaying(state) {
          widget.classList.toggle('is-playing', state);
          pill.setAttribute('aria-label', state ? 'Pause Himalayan Soundscape' : 'Play Himalayan Soundscape');
          /* Persist mute state */
          sessionStorage.setItem(STORAGE_KEY, state ? 'false' : 'true');
        }

        audio.addEventListener('play',  function () { setPlaying(true);  });
        audio.addEventListener('pause', function () { if (!synthActive) setPlaying(false); });
        audio.addEventListener('ended', function () { if (!synthActive) setPlaying(false); });

        /* ── 4. PILL CLICK – play/pause + open tray ── */
        pill.addEventListener('click', function () {
          var isPlaying = !audio.paused || synthActive;
          if (isPlaying) {
            audio.pause();
            stopSynth();
            setPlaying(false);
            /* Close tray on pause */
            tray && tray.classList.remove('is-open');
            tray && tray.setAttribute('aria-hidden', 'true');
            pill.setAttribute('aria-expanded', 'false');
          } else {
            audio.play().then(function () {
              setPlaying(true);
              openTray();
            }).catch(function (err) {
              console.warn('[Soundscape] HTML5 audio blocked, using synth:', err);
              var started = startSynth(audio.volume);
              if (started) {
                setPlaying(true);
                openTray();
              }
            });
          }
        });

        /* ── 5. TRAY HELPERS ── */
        function openTray() {
          if (!tray) return;
          tray.classList.add('is-open');
          tray.setAttribute('aria-hidden', 'false');
          pill.setAttribute('aria-expanded', 'true');
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            tray && tray.classList.remove('is-open');
            tray && tray.setAttribute('aria-hidden', 'true');
            pill.setAttribute('aria-expanded', 'false');
          });
        }

        /* ── 6. VOLUME SLIDER ── */
        if (volSlider) {
          volSlider.addEventListener('input', function (e) {
            var vol = parseFloat(e.target.value) / 100;
            audio.volume = vol;
            if (synthNodes && synthNodes.master && audioCtx) {
              synthNodes.master.gain.setValueAtTime(vol * 0.45, audioCtx.currentTime);
            }
          });
        }
      });
    });
  })();

  /* §10 #7: keep the first mobile fold clear — the pill used to cover the
     section heading sitting right under the 76vh gate hero. Reveal it only
     after the visitor starts scrolling. Desktop unchanged. */
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function bind() {
      var widget = document.querySelector('.asc-widget');
      if (!widget) return;
      /* Beckon: one subtle glow burst the first time the pill reveals per
         session, mobile only. Cleared early if the visitor taps. */
      var beckoned = false;
      try { beckoned = sessionStorage.getItem('soundscape_beckoned') === 'true'; } catch (e) {}
      function maybeBeckon() {
        if (beckoned || !mq.matches || window.scrollY < 420) return;
        beckoned = true;
        try { sessionStorage.setItem('soundscape_beckoned', 'true'); } catch (e) {}
        widget.classList.add('asc-widget--beckon');
        var clear = function () { widget.classList.remove('asc-widget--beckon'); };
        setTimeout(clear, 7000);
        var pill = widget.querySelector('.asc-pill');
        if (pill) pill.addEventListener('click', clear, { once: true });
      }
      function onScroll() {
        if (!mq.matches) {
          widget.classList.remove('asc-widget--gate-hidden');
          return;
        }
        widget.classList.toggle('asc-widget--gate-hidden', window.scrollY < 420);
        maybeBeckon();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bind);
    } else {
      bind();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axis-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var fold = document.querySelector('.axis-lede-fold');
    if (!fold) return;
    var text = fold.querySelector('.axis-lede-fold__text');
    var btn = fold.querySelector('.axis-lede-fold__btn');
    var toggle = fold.querySelector('.axis-lede-fold__toggle');

    function checkOverflow() {
      if (window.innerWidth > 749 || toggle.checked) {
        btn.style.display = '';
        return;
      }
      btn.style.display = text.scrollHeight > text.clientHeight + 1 ? '' : 'none';
    }

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kora-altimeter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hasIO = 'IntersectionObserver' in window;
    document.body.classList.add('js');
    if (!rm && hasIO) document.body.classList.add('js-anim');

    /* ---------- rm notice bar (motion law: tell the user the switch state) ---------- */
    if (rm) {
      var bar = document.createElement('div');
      bar.setAttribute('role', 'status');
      bar.style.cssText =
        'position:fixed;left:0;right:0;bottom:0;z-index:70;background:rgba(8,7,6,.9);' +
        'color:rgba(236,229,216,.55);font-family:var(--kora-font-mono);font-size:10px;' +
        'letter-spacing:.12em;text-align:center;padding:8px 40px 8px 12px;backdrop-filter:blur(8px);';
      bar.textContent = 'MOTION REDUCED PER YOUR SYSTEM SETTING';
      var close = document.createElement('button');
      close.textContent = '×';
      close.setAttribute('aria-label', 'Dismiss');
      close.style.cssText =
        'position:absolute;right:8px;top:50%;transform:translateY(-50%);background:none;' +
        'border:none;color:inherit;font-size:16px;cursor:pointer;padding:8px;';
      close.addEventListener('click', function () { bar.remove(); });
      bar.appendChild(close);
      document.body.appendChild(bar);
      setTimeout(function () { if (bar.parentNode) bar.style.opacity = '0', bar.style.transition = 'opacity 1s'; }, 9000);
      setTimeout(function () { if (bar.parentNode) bar.remove(); }, 10300);
    }

    /* ---------- reveal (.k-line) & zoom ([data-kora-zoom]) ---------- */
    if (hasIO && !rm) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-seen'); revealIO.unobserve(e.target); }
        });
      }, { threshold: 0.18 });
      document.querySelectorAll('.k-line, [data-kora-zoom]').forEach(function (el) { revealIO.observe(el); });
    }

    /* ---------- altimeter: station name + altitude (lerp, rm = instant) ---------- */
    var stations = Array.prototype.slice.call(document.querySelectorAll('[data-kora-station]'));
    var elStation = document.querySelector('[data-alt-station]');
    var elNum = document.querySelector('[data-alt-num]');
    var elFill = document.querySelector('[data-alt-fill]');
    var elReserve = document.querySelector('[data-alt-reserve]');
    var BASE = 4675, SUMMIT = 5630;
    var shown = BASE, target = BASE, rafId = null;

    function fmt(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

    function renderAlt() {
      if (elNum) elNum.textContent = fmt(shown);
      if (elFill) elFill.style.height = Math.max(0, Math.min(100, (shown - BASE) / (SUMMIT - BASE) * 100)) + '%';
    }

    function tick() {
      shown += (target - shown) * 0.08;
      if (Math.abs(target - shown) < 0.6) { shown = target; renderAlt(); rafId = null; return; }
      renderAlt();
      rafId = requestAnimationFrame(tick);
    }

    function setAltitude(alt) {
      target = alt;
      if (rm) { shown = target; renderAlt(); return; }
      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    function setStation(el) {
      if (elStation) elStation.textContent = el.getAttribute('data-station-name') || '';
      var alt = parseFloat((el.getAttribute('data-altitude') || '').replace(/,/g, ''));
      if (!isNaN(alt)) setAltitude(alt);
      /* smart reserve link: object stations carry their own edition + href (SPEC §5.1) */
      if (elReserve) {
        var label = el.getAttribute('data-reserve-label');
        var href = el.getAttribute('data-reserve-href');
        elReserve.textContent = label || 'Reserve';
        elReserve.setAttribute('href', href || '#door');
      }
    }

    if (stations.length) {
      if (hasIO) {
        var stationIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) setStation(e.target); });
        }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
        stations.forEach(function (s) { stationIO.observe(s); });
      }
      setStation(stations[0]);
    }

    /* ---------- parallax: mountain bg + object-number drift (rm: never) ---------- */
    if (!rm) {
      var pxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax] .kora-station__bg img, [data-parallax] > img'));
      var driftEls = Array.prototype.slice.call(document.querySelectorAll('[data-drift]'));
      if (pxEls.length || driftEls.length) {
        var ticking = false;
        var update = function () {
          ticking = false;
          var vh = window.innerHeight;
          pxEls.forEach(function (img) {
            var r = img.parentNode.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            var amt = parseFloat(img.closest('[data-parallax]').getAttribute('data-parallax')) || 38;
            var p = (r.top + r.height / 2 - vh / 2) / vh; /* -0.5 … 0.5 around center */
            img.style.transform = 'translateY(' + (p * amt).toFixed(1) + 'px) scale(1.06)';
          });
          driftEls.forEach(function (el) {
            if (window.innerWidth <= 860) { el.style.transform = ''; return; } /* mobile: number sits fixed, no -50% centering */
            var r = el.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            var amt2 = parseFloat(el.getAttribute('data-drift')) || 30;
            var p2 = (r.top + r.height / 2 - vh / 2) / vh;
            el.style.transform = 'translate(' + (p2 * amt2).toFixed(1) + 'px, -50%)';
          });
        };
        window.addEventListener('scroll', function () {
          if (!ticking) { ticking = true; requestAnimationFrame(update); }
        }, { passive: true });
        update();
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kora-door"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.querySelector('[data-kora-door-date]');
    if (!wrap) return;
    var target = Date.parse(wrap.getAttribute('data-kora-door-date'));
    if (isNaN(target)) return;
    var d = wrap.querySelector('[data-cd-d]'),
        h = wrap.querySelector('[data-cd-h]'),
        m = wrap.querySelector('[data-cd-m]'),
        s = wrap.querySelector('[data-cd-s]');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      var secs = Math.floor(diff / 1000);
      d.textContent = pad(Math.floor(secs / 86400));
      h.textContent = pad(Math.floor((secs % 86400) / 3600));
      m.textContent = pad(Math.floor((secs % 3600) / 60));
      s.textContent = pad(secs % 60);
      if (diff > 0) setTimeout(tick, 1000);
    }
    tick();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  (function () {
    var fold = document.querySelector('.collection-desc-fold');
    if (!fold) return;
    var text = fold.querySelector('.collection-desc-fold__text');
    var btn = fold.querySelector('.collection-desc-fold__btn');
    var toggle = fold.querySelector('.collection-desc-fold__toggle');

    function checkOverflow() {
      if (window.innerWidth > 749 || toggle.checked) {
        btn.style.display = '';
        return;
      }
      btn.style.display = text.scrollHeight > text.clientHeight + 1 ? '' : 'none';
    }

    checkOverflow();
    window.addEventListener('resize', checkOverflow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mani-wall"] && !Shopify.designMode) return;
  try {
    
  /*
    MANI WALL — prototype behaviour only.
    ─────────────────────────────────────────────────────────────────────────
    TODO: 接真实存储 — nothing here talks to a server. A stone is appended to
    the DOM and lost on reload, by design, so the prototype can be reviewed
    without writing demo data into the store.

    Going live needs, in this order:
      1. A metaobject or a customer/metaobject-backed store for stones
         (fields: text, pillar, created_at, status, is_seed=false).
      2. Moderation before display. Words that name a person or a third party
         must never appear on the wall unread.
      3. The counter must come from the real record count (metaobjects count),
         never from a Liquid seed.
      4. Empty the DEMO SEED and delete the `.is-seed` stones.
      5. Move the email hook onto a real marketing signup (a customer form or
         an app), not a second prototype stub.
  */
  (function () {
    var GOLD = '#C8A97E';

    function initManiWall(sectionEl) {
      if (!sectionEl || sectionEl.dataset.mwReady === '1') return;
      sectionEl.dataset.mwReady = '1';

      var wallWrap = sectionEl.querySelector('[data-mw-wall-wrap]');
      var wall = sectionEl.querySelector('[data-mw-wall]');
      var stones = sectionEl.querySelectorAll('[data-mw-stone]');
      if (!wall) return;

      var input = sectionEl.querySelector('[data-mw-input]');
      var submit = sectionEl.querySelector('[data-mw-submit]');
      var confirmEl = sectionEl.querySelector('[data-mw-confirm]');
      var moreBtn = sectionEl.querySelector('[data-mw-more]');
      var countEl = sectionEl.querySelector('[data-mw-count]');
      var countNoun = sectionEl.querySelector('[data-mw-count-noun]');
      var filterNote = sectionEl.querySelector('[data-mw-filter-note]');
      var afterEl = sectionEl.querySelector('[data-mw-after]');
      var checkinEl = sectionEl.querySelector('.mani-wall__checkin');
      var pillars = sectionEl.querySelectorAll('[data-mw-pillar]');
      var emailToggle = sectionEl.querySelector('[data-mw-email-toggle]');
      var emailInput = sectionEl.querySelector('[data-mw-email-input]');
      var emailSend = sectionEl.querySelector('[data-mw-email-send]');
      var isMobile = function () { return window.matchMedia('(max-width: 749px)').matches; };

      /* ── honest count ────────────────────────────────────────────────────
         Counts stones that are ACTUALLY on the wall. No floor, no padding.
         Under 10 it shows the true figure. */
      function recount() {
        var n = wall.querySelectorAll('[data-mw-stone]').length;
        if (!countEl) return;
        countEl.textContent = String(n);
        if (countNoun) countNoun.textContent = n === 1 ? 'stone' : 'stones';
      }

      /* ── which stone belongs to which pillar ─────────────────────────── */
      var myPillar = '';
      function myPillarLabel() {
        var anyLabel = '';
        pillars.forEach(function (p) {
          if (p.getAttribute('data-mw-pillar') === '') anyLabel = p.getAttribute('data-mw-label') || p.textContent.trim();
        });
        if (!myPillar) return anyLabel;
        var name = '';
        pillars.forEach(function (p) {
          if (p.getAttribute('data-mw-pillar') === myPillar) {
            name = p.getAttribute('data-mw-label') || p.textContent.trim();
          }
        });
        return name;
      }

      pillars.forEach(function (p) {
        /* Cache the label text once so the axis line can be rebuilt after a
           click without re-reading a mutated DOM. */
        if (!p.getAttribute('data-mw-label')) {
          var nm = p.querySelector('.mani-wall__pill-name');
          p.setAttribute('data-mw-label', (nm ? nm.textContent : p.textContent).trim());
        }
        p.addEventListener('click', function () {
          var v = p.getAttribute('data-mw-pillar');
          if (myPillar === v) {
            myPillar = '';
            p.setAttribute('aria-pressed', 'false');
          } else {
            myPillar = v;
            pillars.forEach(function (q) {
              q.setAttribute('aria-pressed', q === p ? 'true' : 'false');
            });
          }
          filterWall();
          scrollPillIntoView(p);
        });
      });

      function scrollPillIntoView(p) {
        if (!p || !p.scrollIntoView || !isMobile()) return;
        try {
          p.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        } catch (e) { /* Safari < 15.4 */ }
      }

      /* Filtering never changes the count — the stones are still on the wall,
         they are only narrowed on screen. The count statement stays true. */
      function filterWall() {
        var shown = 0;
        wall.querySelectorAll('[data-mw-stone]').forEach(function (s) {
          var sp = s.getAttribute('data-pillar');
          var on = !myPillar || sp === myPillar;
          s.classList.toggle('mw-hidden', !on);
          s.classList.toggle('mw-match', !!myPillar && on);
          if (on) shown += 1;
        });

        /* The count above stays the REAL total — narrowing the view does not
           change how many stones are on the wall. This note is what tells the
           visitor they are looking at a slice, not at an almost-empty wall. */
        if (filterNote) {
          if (myPillar) {
            filterNote.hidden = false;
            filterNote.textContent = 'showing ' + shown + ' of ' + wall.querySelectorAll('[data-mw-stone]').length;
          } else {
            filterNote.hidden = true;
            filterNote.textContent = '';
          }
        }
      }

      /* ── show more ─────────────────────────────────────────────────────
         Extras start collapsed on desktop; on mobile they are not laid out at
         all until the visitor asks. The `.mw-open` class on the wrapper is the
         single source of truth and drives every stage of the reveal. */
      function syncWallState() {
        var hasExtra = wall.querySelectorAll('.is-extra').length > 0;
        wallWrap.classList.toggle('mw-has-extra', hasExtra);
        if (moreBtn) moreBtn.hidden = !hasExtra;
      }

      if (moreBtn) {
        var moreLabel = moreBtn.textContent.trim();
        var lessLabel = moreBtn.getAttribute('data-less-label') || 'Show fewer stones';
        moreBtn.setAttribute('data-more', moreLabel);
        moreBtn.setAttribute('data-less', lessLabel);

        moreBtn.addEventListener('click', function () {
          var open = wallWrap.classList.toggle('mw-open');
          moreBtn.textContent = open ? lessLabel : moreLabel;
          if (!open) {
            try {
              wallWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e) { /* no smooth scroll support */ }
          }
        });
      }

      var lessLabelAttr = sectionEl.getAttribute('data-more-less-label');
      if (moreBtn && lessLabelAttr) moreBtn.setAttribute('data-less-label', lessLabelAttr);

      /* ── place a stone ───────────────────────────────────────────────── */
      function stamp() {
        var d = new Date();
        var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[d.getMonth()] + ' ' + d.getFullYear();
      }

      function placeStone() {
        if (!input) return;
        var text = (input.value || '').replace(/\s+/g, ' ').trim();
        if (!text) {
          input.focus();
          return;
        }
        if (text.length > 60) text = text.slice(0, 60);

        var stone = document.createElement('article');
        stone.className = 'mani-wall__stone is-mine';
        stone.setAttribute('data-mw-stone', '');
        stone.setAttribute('data-pillar', myPillar || '');
        stone.setAttribute('data-text', text);
        stone.innerHTML =
          '<span class="mani-wall__grain" aria-hidden="true"></span>' +
          '<span class="mani-wall__stone-date"></span>' +
          '<p class="mani-wall__stone-text"></p>' +
          '<span class="mani-wall__stone-axis"></span>';
        stone.querySelector('.mani-wall__stone-date').textContent = stamp();
        stone.querySelector('.mani-wall__stone-text').textContent = text;
        stone.querySelector('.mani-wall__stone-axis').textContent = myPillarLabel();

        /* The previous "mine" stone stays on the wall. The wall accumulates
           — that is the whole point of the section. */
        var prev = wall.querySelectorAll('.mani-wall__stone.is-mine');
        prev.forEach(function (s) { s.classList.remove('is-mine'); s.classList.add('is-returning'); });

        wall.appendChild(stone);
        recount();
        filterWall();
        syncWallState();

        if (confirmEl) {
          confirmEl.hidden = false;
        }
        input.value = '';

        /* ── THE SECOND QUESTION APPEARS ONLY NOW ─────────────────────────
           Before this point the section asks exactly one thing: what are you
           carrying. The moment a stone exists, the way-in question and the
           email hook fade in together. Two reasons, both measured in the
           founder's own reading of round two:
             · one question at a time is why the first one gets answered;
             · finishing the first act and immediately being offered a small
               second one raises completion, instead of presenting four
               competing controls before anything has happened.
           Focus moves to the field they just emptied, so the next thing they
           can do (choose a way in) is one tap away, not announced by a jump. */
        if (afterEl) {
          afterEl.hidden = false;
          if (afterEl.getAnimations) {
            try { afterEl.getAnimations().forEach(function (a) { a.play(); }); } catch (e) { /* older engines */ }
          }
        }
        if (isMobile()) {
          try {
            if (checkinEl) checkinEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          } catch (e) { /* no smooth scroll */ }
        }

        /* Bring their stone into view. On mobile the wall is one horizontal
           band, so the strip itself has to be scrolled — and the collapsed
           extras are revealed first, otherwise the band would not contain the
           new stone. On desktop the whole pile is already in view and opening
           the extra stones unasked would be a lie about how full the wall is. */
        if (isMobile()) {
          wallWrap.classList.add('mw-open');
          syncWallState();
          wallWrap.scrollTop = 0;
          try {
            wall.scrollTo({ left: wall.scrollWidth, behavior: 'smooth' });
          } catch (e) {
            wall.scrollLeft = wall.scrollWidth;
          }
        }
      }

      if (submit) submit.addEventListener('click', placeStone);
      if (input) {
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            placeStone();
          }
        });
      }

      /* ── email hook: separate, optional, cannot block placing a stone ── */
      if (emailSend) {
        emailSend.addEventListener('click', function () {
          var v = emailInput ? (emailInput.value || '').trim() : '';
          if (!v || v.indexOf('@') === -1) {
            if (emailInput) emailInput.focus();
            return;
          }
          /* TODO: 接真实存储 — no request is sent in the prototype. */
          emailSend.textContent = 'Noted';
          if (emailInput) {
            emailInput.value = '';
            emailInput.placeholder = 'We will write once.';
          }
        });
      }

      /* ── COLUMN BALANCE ASSERTION ────────────────────────────────────────
         The wall's layout contract is that no column is left with a hole big
         enough to read as broken, at ANY seed count.

         Two earlier versions of this check were wrong, and both are worth
         recording so nobody rebuilds them:
           · v1 measured stone bottom edges. A collapsed "extra" has zero
             height, so a column whose last laid-out stone is in row 1 measured
             as ending far above one whose last stone is in row 3. It reported
             a 91% spread on a wall whose columns were in fact level.
           · v2 measured the grid's own row tracks. Every column shares the row
             tracks, so that always sums to the same number — it reported 0%
             for any wall whatsoever, including a deliberately broken one. A
             check that cannot fail is not a check.

         v3, below, measures what was actually meant: for every row that has
         any stone on screen, which columns are empty in that row, and how much
         height those empty cells represent. The deficit is compared against
         the shortest column's depth — that is the "hole bigger than one column
         width" the design must never show.

         The visible rows are fully populated by the matrix in the stylesheet,
         so a correct wall reports a 0% deficit, while a genuinely broken one
         reports a real number and warns. */
      var BALANCE_LIMIT = 0.4;

      function assertColumnBalance() {
        /* Desktop only. Below 750px the grid is not columns at all — it is one
           horizontal scroll band, where this measurement is meaningless. */
        if (isMobile()) return null;

        var gridStyle = window.getComputedStyle(wall);
        var colCount = gridStyle.gridTemplateColumns.split(' ').length;
        if (colCount < 2) return null;

        var trackText = gridStyle.gridTemplateRows;
        if (!trackText || trackText === 'none') return null;
        var tracks = trackText.split(' ').map(parseFloat);
        if (!tracks.length || tracks.some(isNaN)) return null;

        var gap = parseFloat(gridStyle.rowGap) || 0;

        /* The grid's resolved column tracks, in page coordinates. Used to work
           out how many columns a stone actually covers, because the computed
           `gridColumnEnd` cannot be trusted here (see below). */
        var gridBox = wall.getBoundingClientRect();
        var colStarts = [];
        var colEnds = [];
        var colCursor = gridBox.left;
        var colTracks = gridStyle.gridTemplateColumns.split(' ').map(parseFloat);
        var colGap = parseFloat(gridStyle.columnGap) || 0;
        for (var ct = 0; ct < colTracks.length; ct++) {
          colStarts.push(colCursor);
          colEnds.push(colCursor + colTracks[ct]);
          colCursor += colTracks[ct] + colGap;
        }

        var rowLive = [];      /* rows holding at least one visible stone */
        var rowCols = [];      /* which columns hold a stone in that row */
        var unmeasured = 0;    /* stones whose span could not be derived */

        wall.querySelectorAll('[data-mw-stone]').forEach(function (s) {
          if (s.classList.contains('mw-hidden')) return;
          var st = window.getComputedStyle(s);
          if (st.display === 'none') return;
          /* A collapsed extra occupies its cell with no height and no border —
             it is not on screen, so it must not count as filling a row. */
          var box = s.getBoundingClientRect();
          if (box.height < 1) return;

          var r = parseInt(st.gridRowStart, 10);
          if (isNaN(r) || r < 1 || r > tracks.length) return;

          /* HOW MANY COLUMNS THIS STONE ACTUALLY COVERS.
             Three attempts were needed, and the third is the one that works:
               · treating `gridColumnEnd` as an inclusive index. It is an
                 EXCLUSIVE grid LINE, so a stone in column 3 reports c=3,
                 cEnd=4 and the fill loop ran zero times;
               · defaulting a non-numeric `gridColumnEnd` to the full width.
                 For exactly these stones the computed value is the keyword
                 `auto`, NOT a line number — so every stone was recorded as
                 filling every column and the check could not find a hole in
                 any layout, including a deliberately broken one;
               · matching the stone's bounding-box edges against the column
                 tracks. The stagger classes translate stones by 2-4px, so a
                 LEFT edge landed near the previous column's RIGHT edge and the
                 correct wall reported two holes it did not have.
             So the span is derived from the stone's WIDTH — a transform does
             not change layout width — compared against the grid's own resolved
             column-span widths. No dependence on how the placement was written,
             and no dependence on where the stone was nudged to. */
          var span = -1;
          for (var n = 1; n <= colTracks.length; n++) {
            var wantW = 0;
            for (var k = 0; k < n; k++) wantW += colTracks[k];
            wantW += colGap * (n - 1);
            if (Math.abs(box.width - wantW) < 3) { span = n; break; }
          }
          if (span < 0) {
            /* Unknown geometry — report it rather than silently passing. */
            unmeasured += 1;
            return;
          }

          var start = colStarts.length;
          for (var ci = 0; ci < colStarts.length; ci++) {
            if (Math.abs(box.left - colStarts[ci]) < colTracks[0] * 0.5 + 8) start = ci;
          }
          if (start >= colStarts.length) start = 0;
          var end = Math.min(colStarts.length - 1, start + span - 1);

          rowLive[r - 1] = true;
          rowCols[r - 1] = rowCols[r - 1] || [];
          for (var x = start; x <= end; x++) rowCols[r - 1][x] = true;
        });

        var live = [];
        for (var r2 = 0; r2 < tracks.length; r2++) if (rowLive[r2]) live.push(r2);
        if (live.length < 2) return null;

        var columnDepth = [];
        var holes = [];
        live.forEach(function (ri) {
          for (var c2 = 0; c2 < colCount; c2++) {
            var filled = rowCols[ri] && rowCols[ri][c2];
            columnDepth[c2] = (columnDepth[c2] || 0) + tracks[ri] + gap;
            if (!filled) {
              holes.push({ row: ri + 1, column: c2 + 1, px: Math.round(tracks[ri]) });
            }
          }
        });

        var depths = columnDepth.filter(function (d) { return d > 0; });
        var shortest = Math.min.apply(null, depths);
        var deepest = Math.max.apply(null, depths);
        var holePx = holes.reduce(function (a, h) { return a + h.px; }, 0);
        var spread = shortest > 0 ? (deepest - shortest + holePx) / shortest : 0;

        var result = {
          columns: colCount,
          rowTracks: tracks.map(function (t) { return Math.round(t); }),
          liveRowCount: live.length,
          columnDepths: columnDepth.map(function (d) { return Math.round(d); }),
          shortestColumn: Math.round(shortest),
          deepestColumn: Math.round(deepest),
          emptyRowCells: holes,
          emptyCellPx: Math.round(holePx),
          unmeasuredStones: unmeasured,
          spreadPercent: Math.round(spread * 1000) / 10,
          limitPercent: BALANCE_LIMIT * 100,
          balanced: spread <= BALANCE_LIMIT
        };

        if (!result.balanced || unmeasured > 0) {
          /* Loud on purpose: an unbalanced wall is a bug, not a style, and a
             stone whose cell cannot be derived must never pass silently. */
          console.warn('[mani-wall] column balance beyond limit', result);
        }
        return result;
      }

      /* ── init ────────────────────────────────────────────────────────── */
      recount();
      syncWallState();
      /* Wait for the webfonts, otherwise Cinzel's fallback metrics skew the
         measurement and the assertion reports a spread that does not exist. */
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { assertColumnBalance(); });
      } else {
        assertColumnBalance();
      }
      window.__maniWallBalance = assertColumnBalance;
      if (emailToggle) {
        emailToggle.addEventListener('change', function () {
          if (emailToggle.checked && emailInput) {
            window.setTimeout(function () { emailInput.focus(); }, 60);
          }
        });
      }
    }

    function initAll() {
      document.querySelectorAll('.mani-wall').forEach(initManiWall);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target && e.target.querySelector ? e.target.querySelector('.mani-wall') : null;
      if (el) initManiWall(el);
      else initAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sanctum-relics"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRelicCarousels() {
      document.querySelectorAll('[data-relics-track]').forEach(function (track) {
        var section = track.closest('.sanctum-relics');
        var dotsWrap = section ? section.querySelector('[data-relics-dots]') : null;
        if (!dotsWrap) return;
        var cards = track.querySelectorAll('.sanctum-relic-card');
        if (cards.length < 2) return;

        dotsWrap.innerHTML = '';
        cards.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'sanctum-relics__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to item ' + (i + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft - 24, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        });

        var ticking = false;
        track.addEventListener(
          'scroll',
          function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              var cardWidth = cards[0].offsetWidth || 1;
              var idx = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / cardWidth)));
              dotsWrap.querySelectorAll('.sanctum-relics__dot').forEach(function (d, i) {
                d.classList.toggle('is-active', i === idx);
              });
              ticking = false;
            });
          },
          { passive: true }
        );
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRelicCarousels);
    } else {
      initRelicCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
